/**
 * Feature flag for parallel gzip compression.
 *
 * When enabled, the Apollo middleware sends an `x-wandb-compression: parallel-gzip`
 * header on large GQL responses, causing the backend to use pgzip (parallel gzip)
 * instead of brotli. This is ~10x faster for content encoding on large payloads.
 *
 * This is a non-React utility so it can be read synchronously from the Apollo Link
 * chain. The Statsig flag value is cached by the useRampFlagParallelGzip hook,
 * which should be called in a top-level component (e.g., App).
 */

let cachedEnabled = false;

export function setParallelGzipEnabled(value: boolean): void {
  cachedEnabled = value;
}

export function isParallelGzipEnabled(): boolean {
  return cachedEnabled;
}
